// src/constants/tasks.js
// Constantes relacionadas a Tarefas (Tasks) / Operacional

import { getOptionsFromMap } from './common';

export const TASK_STATUS = {
    NEW: 'new',
    DOING: 'doing',
    OVERDUE: 'overdue',
    DONE: 'done',
    ARCHIVED: 'archived'
};

export const TASK_STATUS_LABELS = {
    [TASK_STATUS.NEW]: 'Novo',
    [TASK_STATUS.DOING]: 'Fazendo',
    [TASK_STATUS.OVERDUE]: 'Atrasado',
    [TASK_STATUS.DONE]: 'Feito',
    [TASK_STATUS.ARCHIVED]: 'Arquivado'
};

export const TASK_PRIORITY = {
    LOW: 'low',
    NORMAL: 'normal',
    HIGH: 'high',
};

export const TASK_PRIORITY_LABELS = {
    [TASK_PRIORITY.LOW]: 'Baixa',
    [TASK_PRIORITY.NORMAL]: 'Média / Normal',
    [TASK_PRIORITY.HIGH]: 'Alta / Urgente',
};

export const TASK_TYPE = {
    CONTACT: 'contact',
    TECHNICAL: 'technical',
    FINANCIAL: 'financial',
    MAINTENANCE: 'maintenance',
    INTERNAL: 'internal',
};

export const TASK_TYPE_LABELS = {
    [TASK_TYPE.CONTACT]: 'CRM / Contato',
    [TASK_TYPE.TECHNICAL]: 'Professores / Técnico',
    [TASK_TYPE.FINANCIAL]: 'Financeiro / Administrativo',
    [TASK_TYPE.MAINTENANCE]: 'Manutenção de Estrutura',
    [TASK_TYPE.INTERNAL]: 'Gestão / Interno',
};

// Funções utilitárias herdadas para popular dropdowns e options
export const TASK_STATUS_OPTIONS = getOptionsFromMap(TASK_STATUS, TASK_STATUS_LABELS);
export const TASK_PRIORITY_OPTIONS = getOptionsFromMap(TASK_PRIORITY, TASK_PRIORITY_LABELS);
export const TASK_TYPE_OPTIONS = getOptionsFromMap(TASK_TYPE, TASK_TYPE_LABELS);
